import React from 'react';

import AsyncEditorContextProvider from '../../editor-context-provider/components/async-editor-context-provider';

import { WaBonaEditor } from './wa-bonaeditor';
import propTypes, { defaultProps } from './props';


export const WaBonaEditorAdapter = (props) =>
{
  if (!window.document.getElementById('idBonaEditorReactDialogsContainer'))
  {
    window.document.body.insertAdjacentHTML('beforeend', '<div id="idBonaEditorReactDialogsContainer"></div>');
  }

  const { hideLinkStyleOption, editorConfig: { blankPageURL } } = props;

  return (
    <AsyncEditorContextProvider
      blankPageUrl={blankPageURL}
      showLinkStyleOption={!hideLinkStyleOption}
    >
      <WaBonaEditor {...props} />
    </AsyncEditorContextProvider>
  );
};


WaBonaEditorAdapter.propTypes = propTypes;
WaBonaEditorAdapter.defaultProps = defaultProps;

export default WaBonaEditorAdapter;